// extracted by mini-css-extract-plugin
export default {"list":"Career_list__OhG2X","highlight":"Career_highlight__fOgHQ"};